import { Seo } from '../../components/seo';

function ReportsListPage() {
  return (
    <Seo title="Manage Reports" />
  );
}

export default ReportsListPage;
